import { style } from 'typestyle';

export const siteWrapperClassName = style({
    display: 'block',
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    minWidth: '240px'
});
